export default __webpack_public_path__ + "static/sub-banner-de8c2847c084b5162a6a4f41e68c396c.webp";